import variables from '../variables.module.scss';

const pixelsToNumber = (value) => parseFloat(value, 10);
const Breakpoints = {
  values: {
    xs: 0,
    sm: 600,
    md: 900,
    lg: 1200,
    xl: 1536,
    mobile: pixelsToNumber(variables.breakpointMobile),
    custommobile: pixelsToNumber(variables.breakpointCustomMobile),
    customtablet: pixelsToNumber(variables.breakpointCustomTablet),
    tablet: pixelsToNumber(variables.breakpointTablet),
    tabletipad: pixelsToNumber(variables.breakpointTabletIpad),
    customTablet: pixelsToNumber(variables.breakpointTabletCustom),
    customdesktop: pixelsToNumber(variables.breakpointCustomDesktop),
    tabletportrait: pixelsToNumber(variables.breakpointTabletPortrait),
    laptop: pixelsToNumber(variables.breakpointLaptop),
    desktop: pixelsToNumber(variables.breakpointDesktop),
    mediumscreen: pixelsToNumber(variables.breakpointMediumScreen),
    customheadermobile: pixelsToNumber(variables.breakpointCustomHeaderMobile),
    customhomepagetablet: pixelsToNumber(variables.breakpointCustomHomepageTablet),
  },
};

export default Breakpoints;
